<script setup>
defineProps({
  label: { type: String, required: true },
});
</script>

<template>
  <div class="flex items-center px-4 py-2 select-none">
    <div class="h-px flex-1 bg-n-strong/40" />
    <span
      class="mx-3 shrink-0 rounded-full border border-n-weak bg-n-surface-1 px-3 py-1 text-xs text-n-slate-11"
    >
      {{ label }}
    </span>
    <div class="h-px flex-1 bg-n-strong/40" />
  </div>
</template>
